import axios from 'axios'
import {Message} from 'element-ui'
import router from 'vue-router'

// 创建 axios 实例
const request = axios.create({
	// API 请求的默认前缀
	baseURL: process.env.VUE_APP_API_BASE_URL,
	// baseURL: 'http://39.100.16.240:6060/',
	// withCredentials: true,
	timeout: 0 // 请求超时时间
})

// error 异常拦截处理器
const errorHandler = (error) => {
	if (error.response) {
		const data = error.response.data
		if (error.response.status !== 200) {
			Message.error({
				message: '请求异常',
				description: result.message || '请求出现异常，请稍后再试'
			})
		}
		if (error.response.status === 3) {
			Message.error({
				message: '用户登录信息失效',
				description: '用户登录信息已失效，请重新登录！'
			})
		}
    if (error.response.status === 5) {
      Message.error({
        message: error.response.message,
        description: ''
      })
      window.location.reload()
    }
	}
	return Promise.reject(error)
}

// request 请求拦截器
request.interceptors.request.use(config => {
	const token = localStorage.getItem('token')
	// 如果 token 存在
	// 让每个请求携带自定义 token 请根据`实际情况自行修改
	if (token) {
		config.headers['Authorizations'] = token
	}
	return config
}, errorHandler)

// response 响应拦截器
request.interceptors.response.use((response) => {
	// const token = storage.get(ACCESS_TOKEN)
	const result = response.data

	if (result.status === 1) {
		Message.error({
			message: result.message || '请求出现异常，请稍后再试',
			// description: result.message || '请求出现异常，请稍后再试'
		})
		return Promise.reject(response)
	} else if (result.status === 1) {
		Message.error({
			message: '请求失败',
			description: ''
		})
		return Promise.reject(response)
	} else if (result.status === 2) {
		Message.error({
			message: '系统异常',
			description: ''
		})
		return Promise.reject(response)
	} else if (result.status === 3) {
		Message.error({
			message: '用户登录信息失效',
			description: '用户登录信息已失效，请重新登录！'
		})
    localStorage.clear();
    setTimeout(() => {
      window.location.reload()
    }, 2000)
		return Promise.reject(response)
	} else if (result.status === 4) {
		Message.error({
			message: '权限不足',
			description: result.message || '请联系管理员'
		})
		return Promise.reject(response)
	}else if (result.status === 5) {
    Message.error({
      message: result.message,
      description: ''
    })
    localStorage.clear();
    setTimeout(() => {
      window.location.reload()
    }, 2000)
    return Promise.reject(response)
  } else if (response.config.url.indexOf('/appointment/carManage/downloadCarEwm') >= 0) {
		return response
	}

	return result
}, errorHandler)


function is_excel (response) {

	if (response.config.url.indexOf('/appointment/statistics/queryUnUsingUnitScanCodeListExport') >= 0) {
		return true
	} else if (response.config.url.indexOf('/appointment/carManage/exportCarManageList') >= 0) {
		return true
	} else if (response.config.url.indexOf('/appointment/driverManage/exportDriverManageList') >= 0) {
		return true
	} else {
		return false
	}
}

export default request


